import Api from './api';

const QuestionService = {
  index: (limit) => Api.get(`/question/list?offset=0&limit=${limit}`, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  register: (params) => Api.post('/question/register', params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  edit: (params) => Api.post('/question/edit', params, { headers: {'Authorization': sessionStorage.getItem('token')} }),

  delete: (question) => Api.post('/question/remove', { "_id": question._id }, { headers: {'Authorization': sessionStorage.getItem('token')} }),
}

export default QuestionService;
